const OUTPUT_DELIMITER_PATTERNS = [
  /<abc123>/gi,
  /<\/abc123>/gi,
  /<chunk>/gi,
  /<\/chunk>/gi,
  /\$\$\$/g,
  /\^\^\^/g,
  /```/g,
];

/** Strip model delimiter artifacts and fenced-code wrappers from assistant text. */
export function sanitizeLLMOutput(content: string): string {
  let out = content || "";
  OUTPUT_DELIMITER_PATTERNS.forEach((pattern) => {
    out = out.replace(pattern, "");
  });
  const trimmed = out.trim();
  if (trimmed.startsWith("```")) {
    out = trimmed.replace(/^```[\w-]*\s*\n?/, "");
    out = out.replace(/\n?```\s*$/, "");
  }
  return out.trim();
}
